export default __webpack_public_path__ + "static/media/18.164c31e8.jpg";